import "./PartnershipsList.css";

export const PartnershipFreeShipping = ({ partnership }) => {
  return (
    (partnership.yfs_discount || partnership.free_shipping) && (
      <div className="partnerships-list__item-description">
        <p>
          {partnership.yfs_discount
            ? "Site Wide Discount"
            : "Multiple Product Discount"}
        </p>
      </div>
    )
  );
};

export const PartnershipDiscount = ({
  partnership,
  isDetail = false,
  isFeaturedProd = false,
}) => {
  return (
    (partnership.yfs_discount ||
      partnership.free_shipping ||
      partnership.label) && (
      <div
        className={
          isDetail
            ? "partnerships-list__item-shipping-no-float"
            : isFeaturedProd
            ? "partnerships-list__item-shipping-featured"
            : "partnerships-list__item-shipping"
        }
      >
        <span className="partnerships-list__item-shipping-text">Discount</span>
        <span className="partnerships-list__item-shipping-value">
          {partnership.free_shipping
            ? "Free shipping"
            : partnership.label
            ? partnership.label
            : `${partnership.yfs_discount_percentage}%`}
        </span>
      </div>
    )
  );
};
